<template>
  <v-toolbar
    id="core-toolbar"
    flat
    prominent
    dark
  >
    <div class="v-toolbar-title">
        <v-toolbar-title
        class="tertiary--text font-weight-light"
        >
        <v-btn
            v-if="responsive"
            class="default v-btn--simple"
            dark
            icon
            @click.stop="onClickBtn"
        >
            <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
        </v-toolbar-title>
    </div>
    <v-spacer></v-spacer>
    <v-toolbar-items>
        <v-btn flat @click="logout">LogOut</v-btn>
    </v-toolbar-items> 
  </v-toolbar>
</template>

<script>
import { mapMutations } from 'vuex'
import firebase from 'firebase'
export default {
    data(){
        return{
            title: null,
            responsive: false,
            responsiveInput: false
        }
    },
    watch: {
        '$route' (val) {
            this.title = val.name
        }
    },
    methods:{
        logout(){
            firebase.auth().signOut()
            .then(()=>{
                this.$router.replace({path:'/login'})
            })
        },
        ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
        onClickBtn () {
            this.setDrawer(!this.$store.state.app.drawer)
        },
        onClick () {
        //
        },
        onResponsiveInverted () {
            if (window.innerWidth < 991) {
                this.responsive = true
                this.responsiveInput = false
            } else {
                this.responsive = false
                this.responsiveInput = true
            }
        }
    },
    mounted () {
        this.onResponsiveInverted()
        window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeDestroy () {
        window.removeEventListener('resize', this.onResponsiveInverted)
    },
}   
</script>

<style>
  #core-toolbar a {
    text-decoration: none;
  }
</style>
